"use client";

import { useEffect } from "react";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.JSX.Element {
  useEffect(() => {
    console.error("[ErrorBoundary]", error);
  }, [error]);
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
        background: "#f2f3f3",
      }}
    >
      <Container header={<Header variant="h1">Something went wrong</Header>}>
        <SpaceBetween size="m">
          <Box variant="p">
            An unexpected error occurred. Try refreshing the page. If the
            problem persists, contact support.
          </Box>
          <SpaceBetween size="xs" direction="horizontal">
            <Button onClick={reset} variant="primary">
              Refresh
            </Button>
            <Button href="/dashboard/gla-summary">Go to Dashboard</Button>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </div>
  );
}
